import React, { useState,useEffect } from "react";
import Button from "./Button";
import Container from "./Container";

import Table1 from "./Table1";
import { useReducer } from "react";
import Urls from '../Urls'
import { reducer,initialState } from "../reducers/reducers";
import Dropdown from "./Dropdown";
import NewClient from "./NewClient";
import EditText from "./EditText";
import ViewClient from "./ViewClient";
import { useAuth } from "./AuthProvider";
import API_URLS from "../Urls";

const Clients = () => {
    const [fetchedClients,setFetchedClients] = useState([{}])
    const [searchOption, setSearchOption] = useState('id')
    const [selectedClient, setSelectedClient] = useState()
    const [searchData,setSearchData] = useState('');
    const [state, dispatch] = useReducer(reducer, initialState);
    // Estados para paginación
    const [page, setPage] = useState(1);
    const [perPage] = useState(30); // Fijo a 30 como en el backend
    const [lastPage, setLastPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [isSearching, setIsSearching] = useState(false);
    
    // Obtener permisos del usuario
    const { canRead, canWrite } = useAuth();
    const canReadClientes = canRead('acceso_clientes');
    const canWriteClientes = canWrite('acceso_clientes');
    const deleteData =(url,onSuccesful)=>{ // Función para obtener los datos del catálogo
        // Verificar si el usuario tiene permisos de lectura
        console.log(url)
        if (!canWriteClientes) {
            console.error('No tienes permisos para eliminar');
            alert('No tienes permisos para eliminar');
            return Promise.reject('No tienes permisos para eliminar');
        }

        fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => { // Verifica si la respuesta es ok
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(data => {if (typeof onSuccesful === 'function') onSuccesful(data);
            console.log(data); })// Update the state with fetched data})
        .catch(error => console.error('There was a problem with the fetch operation:', error));
    }
    const fetchClients =()=>{
        // Agregar parámetros de paginación
        const paginatedUrl = `${Urls.CLIENTS}?page=${page}&per_page=${perPage}`;
        console.log(`Solicitando clientes: ${paginatedUrl}`);
        
        fetch(paginatedUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(result => {
            // Si la respuesta es paginada
            if (result && result.data && result.page !== undefined) {
                console.log(`Respuesta paginada: ${result.data.length} clientes, página ${result.page} de ${result.last_page}, total: ${result.total}`);
                console.log(result)
                const formattedClients = result.data.map(item => ({
  id: item.id,
  nombre: item.nombre || '',
  apellidos: item.apellidos || '',
  telefono: item.telefono || '',
  correo: item.correo || ''
}));
                
                setFetchedClients(formattedClients);
                setLastPage(result.last_page);
                setTotal(result.total);
            } else {
                // Respaldo para respuesta no paginada
                const dataArray = Array.isArray(result) ? result : [];
                console.log(`Respuesta no paginada: ${dataArray.length} clientes`);
                
                const formattedClients = dataArray.map(item => ({
                    id: item.id,
  nombre: item.nombre || '',
  apellidos: item.apellidos || '',
  telefono: item.telefono || '',
  correo: item.correo || ''
                }));
                
                // Aplicar paginación local
                const calculatedLastPage = Math.ceil(dataArray.length / perPage) || 1;
                console.log(`Calculando paginación local: ${calculatedLastPage} páginas`);
                
                // Aplicar paginación local a los datos
                const startIndex = (page - 1) * perPage;
                const endIndex = Math.min(startIndex + perPage, formattedClients.length);
                const paginatedData = formattedClients.slice(startIndex, endIndex);
                
                setFetchedClients(paginatedData);
                setLastPage(calculatedLastPage);
                setTotal(dataArray.length);
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            setFetchedClients([]);
            setLastPage(1);
            setTotal(0);
        });
    }
    const searchClients = () => {
        if (!searchOption || !searchData.trim()) {
            alert('Por favor seleccione una opción de búsqueda y escriba un texto');
            return;
        }
        
        setIsSearching(true);
        setPage(1); // Reiniciar a la primera página
        
        console.log(`Buscando clientes: ${searchOption}=${searchData}`);
        fetch(Urls.CLIENTS+`?${searchOption}=${searchData}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            
            return response.json();
        })
        .then(result => {
            const dataArray = Array.isArray(result) ? result : 
                           (result && result.data ? result.data : []);
            
            console.log(`Resultados de búsqueda: ${dataArray.length} clientes encontrados`);
            
            const formattedClients = dataArray.map(item => ({
                id: item.id,
  nombre: item.nombre || '',
  apellidos: item.apellidos || '',
  telefono: item.telefono || '',
  correo: item.correo || ''
            }));
            
            // Aplicar paginación local a los resultados de búsqueda
            const calculatedLastPage = Math.ceil(formattedClients.length / perPage) || 1;
            
            // Obtener solo los datos de la página actual
            const startIndex = (page - 1) * perPage;
            const endIndex = Math.min(startIndex + perPage, formattedClients.length);
            const paginatedData = formattedClients.slice(startIndex, endIndex);
            
            setFetchedClients(paginatedData);
            setLastPage(calculatedLastPage);
            setTotal(formattedClients.length);
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
            setFetchedClients([]);
            setLastPage(1);
            setTotal(0);
        })
        .finally(() => {
            // No desactivamos isSearching para mantener el estado de búsqueda
        });
    }
    
    // Función para limpiar la búsqueda
    const clearSearch = () => {
        
        setIsSearching(false);
        setPage(1); // Reiniciar a la primera página
    }

    useEffect(() => {
        if (isSearching) {
            // Si estamos en modo búsqueda y cambia la página, aplicamos paginación local
            // a los resultados de búsqueda que ya tenemos
            const dataArray = Array.isArray(fetchedClients) ? fetchedClients : [];
            
            // Aplicar paginación local a los resultados de búsqueda
            const calculatedLastPage = Math.ceil(total / perPage) || 1;
            
            // Obtener solo los datos de la página actual
            const startIndex = (page - 1) * perPage;
            const endIndex = Math.min(startIndex + perPage, total);
            
            // Necesitamos volver a hacer la búsqueda para obtener todos los datos
            // y luego aplicar la paginación local
            searchClients();
        } else {
            // Si no estamos buscando, obtenemos datos normales
            fetchClients();
        }
    }, [page, isSearching]); // Se ejecuta cuando cambia la página o cuando cambia el estado de búsqueda

    // Controles de paginación
    function PaginationControls() {
        // Siempre mostrar controles, tanto para datos normales como para resultados de búsqueda
        
        // Estilos para los botones
        const buttonStyle = {
            backgroundColor: '#7AACE3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 16px',
            margin: '0 5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            transition: 'background-color 0.3s'
        };

        const disabledButtonStyle = {
            ...buttonStyle,
            backgroundColor: '#cccccc',
            cursor: 'not-allowed',
            opacity: 0.7
        };
        
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '15px 0' }}>
                <button 
                    onClick={() => setPage(prev => Math.max(prev - 1, 1))} 
                    disabled={page === 1}
                    style={page === 1 ? disabledButtonStyle : buttonStyle}
                >
                    &lt; Anterior
                </button>
                <span style={{ margin: '0 15px', fontWeight: 'bold' }}>
                    Página {page} de {lastPage} ({total} registros)
                    {isSearching && ' - Resultados de búsqueda'}
                </span>
                <button 
                    onClick={() => setPage(prev => Math.min(prev + 1, lastPage))} 
                    disabled={page === lastPage}
                    style={page === lastPage ? disabledButtonStyle : buttonStyle}
                >
                    Siguiente &gt;
                </button>
            </div>
        );
    }
    
    return(
        <div className="anylayout">
            <div className="titleFont">Clientes</div>
              
            
            <Container>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                    <div>Buscar por:</div>
                    <Dropdown options={['Id', 'Nombre', 'Telefono']} returnSelectedOption={(data)=>{
                        setSearchOption(data.toLowerCase());
                    }}></Dropdown>
                    <EditText 
                        text="Buscar" 
                        value={searchData}
                        onChange={(data)=>{setSearchData(data)}}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                searchClients();
                            }
                        }}
                    ></EditText>
                    <Button text="🔎" color="#7AACE3" onClick={()=>{
                        searchClients();
                    }}></Button>
                    {isSearching && (
                        <Button text="Limpiar búsqueda" onClick={clearSearch} color="#DF7476" />
                    )}
                </div>
                {canWriteClientes && (
                    <Button text="Anadir Cliente" onClick={()=>{dispatch({type:'openNewClient'})}} color="#7AACE3"></Button>
                )}
            </Container>

            {isSearching && (
                <div style={{ textAlign: 'center', margin: '10px 0', fontStyle: 'italic' }}>
                    Mostrando resultados de búsqueda para: "{searchData}" ({total} resultados)
                </div>
            )}
            <PaginationControls />
            <Table1 headers={['id','Nombre','Apellidos','Telefono','Correo']} optview={canReadClientes} onClickView={(data)=>{setSelectedClient(data); console.log(data);dispatch({type:'openViewClient'})}}data={fetchedClients}></Table1>
            <PaginationControls />

            {state.statusNewClient && (
                <NewClient onAccept={()=>{dispatch({type:'closeNewClient'});setFetchedClients(fetchClients)}}onClose={()=>{dispatch({type:'closeNewClient'})}}></NewClient>
             )}
            {state.statusViewClient && (
                <ViewClient onDelete={()=>{deleteData(API_URLS.CLIENTS+'?id='+selectedClient.id,()=>{
                    setFetchedClients(fetchedClients.filter(item=>item.id!=selectedClient.id));
                    alert('Cliente eliminado correctamente');
                    dispatch({type:'closeViewClient'});
                })}} client={selectedClient} onClose={()=>{dispatch({type:'closeViewClient'})}}></ViewClient>
            )}
            
             
        </div>
    );
}
export default Clients;